import { useCallback, useState } from "react";
import { fget } from "../API/callsAPI";

export const NavbarConfigHook = () => {
  const [navConfig, setNavConfig] = useState(null);

  const getNavConfig = useCallback(async (projectId) => {
    if (!projectId) {
      return null;
    }

    try {
      const response = await fget({
        url: `/project/${projectId}/navbar-configs/`,
      });
      const data = response.data.results?.[0] || response.data;
      setNavConfig(data);
      return data;
    } catch (error) {
      console.error(error);
      setNavConfig(null);
      return null;
    }
  }, []);

  return {
    navConfig,
    getNavConfig,
  };
};
